import * as React from 'react'

function PolicyIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 6614"
            transform="translate(103 257)"
            fill="none"
            stroke="#707070"
            strokeWidth={1}
            d="M0 0H24V24H0z"
          />
        </clipPath>
      </defs>
      <g data-name="my policy active" transform="translate(-103 -257)" clipPath="url(#a)">
        <g data-name="Group 7791" fill="CurrentColor">
          <path
            data-name="Path 17332"
            d="M-17416.275-4976.125l-9.025 3.2a27.374 27.374 0 001 9.283c.545 1.563 2.17 3.239 4.7 4.849a28.239 28.239 0 003.324 1.8 29.689 29.689 0 003.438-1.812c2.6-1.613 4.277-3.292 4.842-4.855a25.906 25.906 0 001.008-9.252l-9.289-3.214m-.008-1.907l11 3.807s.7 6.378-1.021 11.175-9.982 8.018-9.982 8.018-8.041-3.22-9.713-8.018-1.023-11.175-1.023-11.175z"
            transform="translate(2.5 -29.105) translate(17528.639 5265.137)"
          />
          <path
            data-name="Path 17325"
            d="M12.25-7.549a.9.9 0 01-.521-.167L9.808-9.081l1.043-1.467 1.266.9 1.924-2.141 1.339 1.2-2.46 2.742a.9.9 0 01-.67.298z"
            transform="translate(2.5 -29.105) translate(99.981 307.61)"
          />
        </g>
      </g>
    </svg>
  )
}

export default PolicyIcon
